<template>
  <section
    ref="container"
    class="page-container">
    <div
      class="main-header ">
      <div class="flex-sb">
        <div class="">

          <div class="header-title flex">
            <template>
              <span
                class="icon color-gray"
              >
                <font-awesome-icon icon="people-group" />
              </span>
            </template>
            <h3>{{ teamLeaderData.name }}</h3>
          </div>
          <div class="mg-b-8">
            <span class="header-date">Created  <span class="number-color number-fontsize">{{ teamLeaderData.created_at }}</span></span>
            <span class="header-date">Last Login  <span class="number-color number-fontsize">{{ teamLeaderData.last_login }}</span></span>
          </div>
        </div>
      </div>
      <el-tabs
        v-model="activeTab"
      >
        <el-tab-pane
          v-for="(item, index) in month"
          :key="index"
          :name="item.quarter"
        >
          <span slot="label">
            <span>
              <font-awesome-icon
                class="icon"
                icon="bullseye"></font-awesome-icon>
              <span>{{item.value}}</span>
            </span>
          </span>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div
      class="main-container">
      <div
        class="main-col">
        <div class="middle-col">

          <div class="show-data__container">
            <span class="title">Quarterly Settlement Date <span class="date">{{quarter_data.value}}</span></span>
            <ul>
              <li>
                <p>Total No. of Policies Issued</p>
                <p>{{summary.policies}}</p>
              </li>
              <li>
                <p>Sum of Gross Premiums HK$</p>
                <p>{{summary.premiums | formatMoney(2, false)}}</p>
              </li>
              <li :class="[summary.active_member<50?'red':'green']">
                <p>{{ quarter_data.value }} Active Member</p>
                <p>{{summary.active_member}}%</p>
              </li>
            </ul>
          </div>
          <div class="flex-sb-center">
            <div class="form-item flex-1">
              <span>Search</span>
              <v-input
                v-model="search"
                placeholder="Mobile No. / Name"
                @keyEnter="filterData"
              />
            </div>
            <div class="form-item flex-1">
              <span>Status</span>
              <v-select
                v-model="stts"
                :list="sttsList"
                @change="filterData"
              />
            </div>
          </div>
          <div class="detail">
            <div class="transparent">
              <el-table
                :data="tableData"
                style="width: 100%"
                :row-class-name="tableRowClassName"
                :header-row-class-name="'tableHeader'"
              >
                <el-table-column
                  width="60px"
                  align="center">
                  <template>
                    <div
                      class="flex-algin"
                    >
                      <p class="icon icon-text">
                        <font-awesome-icon
                          icon="user"
                          class="icon-color"/>
                      </p>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  width="105px"
                  label="Created Date">
                  <template #default="{row}">
                    <div class="flex-algin time-text">
                      <span>{{ row.date.split(" ")[0] }}</span><br>
                      <span> {{ row.date.split(" ")[1] }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  width="105px"
                  label="Last Login">
                  <template #default="{row}">
                    <div class="flex-algin time-text">
                      <span>{{ row.last_login.split(" ")[0] }}</span><br>
                      <span> {{ row.last_login.split(" ")[1] }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="Team Leader">
                  <template #default="{ row }">
                    <span class="break-word">{{row.name}}</span>
                    <p class="liter-text">{{row.email}}</p>
                    <p class="liter-text">{{row.contact}}</p>
                  </template>
                </el-table-column>
                <el-table-column
                  label="No. of Referral Activities">
                  <template #default="{ row }">
                    <div class="flex">
                      <div
                        v-for="(item,index) in row.quarter"
                        :key="index"
                        class="row-flex">
                        <p class="break-word">{{item.number}}</p>
                        <p class="liter-text">{{item.month}}</p>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="Gross Premiums HK$">
                  <template #default="{ row }">
                    <span class="break-word">{{row.premiums | formatMoney(2, false)}}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <v-pagination
              :total="pageConfig.total"
              :current="pageConfig.currentPage"
              @currentChange="currentChange" />
          </div>
        </div>
        <div class="right-col">
          <div class="">
            <div
              class="box">
              <span class="title">Team Leader</span>
              <div>
                <div class="flex flex-align-center">
                  <div class="customer-ava">
                    <img
                      :src="avt_pic"
                      alt="">
                  </div>
                  <span class="span-status">{{customer_profile.id_type==3?'Company':'Personal'}}</span>
                  <router-link
                    :to="{path:'/accounts/detail',query:{customer_id:customer_profile.id}}"
                    class="flex flex-wrap text-decoration-none">
                    <span
                      v-if="isShowName"
                      class="plan-name hand"
                    >{{ customer_profile.cs_name }} &nbsp;</span>
                    <span
                      v-else
                      class="plan-name hand unname"
                    >Unnamed Account &nbsp;</span>
                  </router-link>
                </div>
                <ul>
                  <li>
                    <span>Joined</span>
                    <span>{{ customer_profile.created_at }}</span>
                  </li>
                  <li>
                    <span>Policy Count</span>
                    <span>{{ customer_profile.policys }}</span>
                  </li>
                  <li>
                    <span>Tags</span>
                    <span>
                      <div
                        v-if="customer_profile.upload_request_stts == 1 || customer_profile.is_tier_base || customer_profile.referral_coupon || customer_profile.referral_discount"
                        class="tag">
                        <div
                          v-if="customer_profile.upload_request_stts == 1"
                          class="span-tag unread-uplod">Unread Upload</div>
                        <div
                          v-if="customer_profile.is_tier_base"
                          class="span-tag professional-status">Professional</div>
                        <div
                          v-if="customer_profile.referral_coupon"
                          class="span-tag coupon-status">Custom Coupon</div>
                        <div
                          v-if="customer_profile.referral_discount"
                          class="span-tag discount-status">Custom Discount</div>
                      </div>

                      <div
                        v-if="customer_profile.verify_language"
                        class="tag">
                        <div
                          class="span-tag"
                          :class="{
                            'verified': customer_profile.verified == 20,
                            'pending_verify ': customer_profile.verified == -1,
                            'not_verify': customer_profile.verified == -2
                          }">{{ customer_profile.verify_language }}</div>
                      </div>

                      <div
                        v-if="customer_profile.is_flagged"
                        class="tag">
                        <div class="span-tag unread-uplod">
                          Flagged
                        </div>
                      </div>
                      <div
                        v-if="has_block_data"
                        class="tag">
                        <div class="span-tag not_verify">
                          Blocked
                        </div>
                      </div>
                    </span>
                  </li>
                </ul>
              </div>
              <contact-customer
                :customerId="customer_profile.id"
                :phone="customer_profile.phone"
                :customerName="customer_profile.cs_name"
                :email="customer_profile.send_email" />
            </div>
          </div>
          <div class="box box-remark">
            <span class="title">Remarks</span>
            <div class="remarks-container">
              <div
                v-for="(item, index) in remarkList"
                :key="index"
                class="remark-box">
                <div class="remark-header">
                  <span>{{ item.cs_name }}</span>
                  <span>{{ item.created_at }}</span>
                </div>
                <p>{{ item.message }}</p>
              </div>
            </div>
            <div class="remark-add">
              <v-input
                v-model="message"
                class="mg-b-15"
                append="Add"
                @handlerAppend="handlerSendRemark"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {mapState} from 'vuex'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import ContactCustomer from '@/views/components/new-contact-customer'
import {getDetailQuarterList, getQuarterMonthList, getQuarterSummary} from '@api/referBonus'
import {addAccountRemark, getAccountDetail} from '@api/account'

export default {
  name: 'ReferBonusDetail',
  components:{
    ContactCustomer,
  },
  mixins: [MixinOptions,MixinFormat],
  data () {
    return {
      detailData: {},
      isShow:false,
      message: '',
      remarkList: [],
      tableData:[],
      search:'',
      stts:0,
      pageConfig:{
        total: 0,
        currentPage: 1
      },
      activeTab:'',
      summary:{},
      month:[],
      customer_profile:{}
    }
  },
  computed:{
    ...mapState('referBonus',['teamLeaderData']),
    id(){
      return this.$route.params.id
    },
    sttsList(){
      return [
        {id:0,name:'All'},
        {id:1,name:'Active'},
        {id:2,name:'None Active'},
      ]
    },
    quarter_data(){
      let arr =  this.month.filter(item=>item.quarter==this.activeTab)
      return arr[0]||{}
    },
    isShowName(){
      let {cs_name,isrd_lst_nm,isrd_fst_nm} = this.customer_profile
      if(cs_name)
        return cs_name.trim()!=''
      else return  false
    },
    has_block_data(){
      let {block_data=[]} = this.customer_profile||{}
      return block_data.length>0
    },
    selectData(){
      return [this.id]
    },
    avt_pic(){
      let {avatar_thumb_url} = this.customer_profile||{}
      return avatar_thumb_url || null
    },
  },
  watch:{
    activeTab:{
      immediate:true,
      async handler(val){
        if(val!=0&&val){
          await this.network().getQuarterSummary()
          this.network().getDetailQuarterList()
        }
      }
    }
  },

  async mounted(){
    await this.network().getQuarterMonthList()
    await this.network().getAccountDetail()
  },
  methods: {
    filterData(){
      this.pageConfig.currentPage = 1
      this.network().getDetailQuarterList()
    },
    tableRowClassName({row}) {
      let {is_active} = row
      if (!is_active) {
        return 'table-pointer__red'
      }
      return 'table-pointer'
    },
    currentChange(page){
      this.pageConfig.currentPage = page
      this.network().getDetailQuarterList()
    },
    handleRefresh(){
      this.network().getHanbergDetail()
    },
    handlerSendRemark(){
      if(this.message){
        this.network().addRemark()
      }
    },
    network(){
      return{
        getDetailQuarterList: async () => {
          const {data} = await getDetailQuarterList({
            user_id: this.id,
            quarter:this.activeTab,
            search:this.search,
            stts:this.stts,
            page:this.pageConfig.currentPage
          })
          this.pageConfig.currentPage = data.current_page
          this.pageConfig.total = data.total
          this.tableData = data.data
          if(this.customer_profile){

          }
        },
        getQuarterMonthList: async () => {
          const {data} = await getQuarterMonthList({
          })
          this.month = data
          let {quarter} = data[0]||{}
          this.activeTab = quarter||''
        },
        getQuarterSummary: async () => {
          let {quarter} = this.quarter_data||{}
          const {data} = await getQuarterSummary({
            user_id: this.id,
            quarter:this.activeTab
          })
          this.summary = data
        },
        getAccountDetail: async () => {
          const {data} = await getAccountDetail({
            customer_id: this.id
          })
          this.customer_profile = data.customer_profile
          this.remarkList = data.remark

        },
        addRemark: async () => {
          const {data} = await addAccountRemark({
            customer_id: this.id,
            message: this.message
          })
          this.message = ''
          this.remarkList.unshift(data)
        },

      }
    }
  },
}
</script>
<style lang='scss' scoped>
@import '../../../../assets/css/pay-main-header';
.page-container {
  position: relative;
  color: #303133;
  background: #fff;
  margin: -20px;
  min-height: 100%;
  padding-bottom: 40px;
  box-sizing: content-box;
  .row-flex{
    display: flex;
    flex-direction: column;
    min-width: 36px;
    margin-right: 8px;
    &:last-child{
      margin-right: 0;
    }

  }
  .flex-1{
    margin-right: 15px;
    &:last-child{
      margin-right: 0;
    }
  }
  .hand{
    cursor:pointer;
  }
  .small{
    font-weight: normal!important;
  }
  .unname{
    font-style:italic;
    font-weight: normal!important;
  }
  .flex-wrap{
    flex-wrap: wrap;
  }
  .top-bar {
    padding-top: 5px;
    color: #e6a23d;
    font-size: 13px;
    font-weight: bold;
    border-top: 2px solid #e6a23d;
  }

  .span-status{
    color: #fff;
    padding: 1px 8px;
    border-radius: 100px;
    margin-right: 15px;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
  }
  .yellow{
    background-color: #DBAB09;
  }
  .red{
    border: 1px solid #CB2431;
    background: #fff;
    color: #D73A49;
  }
  .black{
    border: 1px solid #6A737D;
    background: #fff;
    color: #24292E;
  }
  .purple{
    background-color: #6F42C1;
  }
  .green{
    background: #28A745;
    color: white!important;
  }
  .orange {
    background: #E36209;
  }
  .void{
    background: #d73a49;
  }
  .main-container {
    padding: 0 88px;
    display: flex;
    justify-content: space-between;
    margin: 20px auto 0 auto;
    // max-width: 100%;
    // overflow: auto;
    .detail_title{
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      display: flex;
      align-items: center;
      color: #24292E;
      margin-bottom: 20px;
    }
    .left-col {
      margin-right: 15px;
      width: 250px;
      color: #616266;

      .title {
        display: block;
        margin-bottom: 5px;
        font-weight: bold;
        font-size: 14px;
      }

      .name {
        display: block;
        margin-bottom: 10px;
        font-weight: bold;
        font-size: 16px;
      }

      .label {
        display: inline-block;
        margin: 10px 0;
        font-size: 14px;
        color: #616266;
        font-weight: 500;
      }

      .el-button {
        margin-top: 20px;
      }



      .info-container {
        margin: 10px -15px 0 -15px;
        padding: 0 15px 10px 15px;
        border-top: 1px solid #dddfe7;
        border-bottom: 1px solid #dddfe7;

        .plan-info-box {
          .logo {
            width: 80px;
            height: 45px;

            img {
              max-width: 80px;
              max-height: 45px;
            }
          }

          p {
            padding-left: 10px;
            font-size: 14px;
            line-height: 18px;
            font-weight: 500;
            color: #616266;
          }
        }

        .info-box {
          margin: 5px 0 0 0;
          color: #616266;

          & > div:last-child {
            font-size: 14px;
            font-weight: bold;
          }
        }
      }
    }

    .main-col {
      flex: 1;
      display: flex;
    }

    .main-edit {
      .top-header {
        display: flex;

        .card:last-child {
          margin-left: 15px;
          width: 250px;
        }

        .title {
          display: inline-block;
          margin-bottom: 10px;
          font-size: 14px;
          font-weight: bold;
        }

        .btn-list {
          .el-button {
            display: block;
            margin: 0 0 5px 0;
          }
        }
      }
    }
    .buy-quote-container{
      flex: 1;
    }
    .middle-col {
      flex: 1;
      min-width: 600px;
      .show-data__container{
        margin-bottom: 20px;
        .title{
          font-weight: 600;
          font-size: 14px;
          line-height: 20px;
          color: #586069;
          display: inline-block;
          .date{
            margin-left: 8px;
            display: inline-block;
            font-weight: 400;
            color: #24292E;
          }
        }
        ul{
          display: flex;
          margin-top: 20px;
          li{
            list-style: none;
            flex: 1;
            background: #F6F8FA;
            border: 1px solid #E1E4E8;
            border-radius: 6px;
            margin-right: 15px;
            padding: 16px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            &:last-child{
              margin-right: 0;
            }
            &.green{
              background: #DCFFE4;
              border: 1px solid rgba(23, 111, 44, 0.2);
            }
            &.red{
              background: #FFE3E6;
              border: 1px solid rgba(158, 28, 35, 0.2);            }
            p{
              font-weight: 600;
              font-size: 12px;
              line-height: 18px;
              color: #586069;
              margin-bottom: 10px;
              &:last-child{
                font-weight: 600;
                font-size: 16px;
                line-height: 24px;
                margin-bottom: 0;
                color: #24292E;
              }
            }
          }
        }
      }
      .card {
        margin-bottom: 15px;
      }

      .draft-container {
        padding: 10px;
        background: #91939A;
        border-radius: 4px;
        color: white;

        span {
          display: block;
        }

        .title {
          font-size: 16px;
          font-weight: bold;
          color: white;
        }

        .msg {
          padding: 5px 0;
          font-size: 14px;
        }
      }
    }

    .info-container {
      color: #616266;

      h1 {
        padding-bottom: 10px;
        font-size: 24px;
      }

      .info-content {
        display: flex;
        justify-content: space-between;
        margin: 0 -15px;
        padding: 0 15px 0 15px;
        // border-top: 1px solid rgba(0, 0, 0, 0.1);
        color: #91939a;
        font-size: 14px;

        .label {
          display: block;
          // margin-bottom: 10px;
          font-size: 14px;
          font-weight: bold;
          color: #616266;
        }
      }
    }

    .right-col {
      margin-left: 30px;
      width: 280px;
      //padding:0 0 0 15px;
      .renew_list{
        margin-bottom: 20px;
        p{
          align-items: center;
          cursor: pointer;
          margin-bottom: 10px;
          .icon{
            width: 22px;
            height: 22px;
            background: #E1E4E8;
            border-radius: 5px;
          }
          .money{
            color: #0366D6;
            font-weight: 400;
            font-size: 16px;
          }
          .amount_tag{
            padding: 3px 12px;
            border-radius: 100px;
            font-weight: 600;
            font-size: 12px;
            font-family: 'Inter';
            font-style: normal;
            margin-left: 15px;
            background: #FFFFFF;
            white-space: nowrap;
          }
          .tag_auto{
            border: 1px solid #0366D6;
            color: #0366D6;
          }
          .tag_terms{
            border: 1px solid #E1E4E8;
            color: #586069;
          }
          .active{
            font-weight: 600;
            font-size: 20px;
            color: #24292E;
          }
        }
        .cursor_default{
          cursor: default;
        }
        .btn{
          .el-button{
            flex: 1;
          }
        }
      }
      .icon{
        margin-right: 15px;
        img{
          height: 22px;
          width: 22px;
        }
      }
      .icon-content{
        height: 22px;
        width: 22px;
        border-radius: 5px;
        background-color: #E1E4E8;
        color: #6A737D;
        font-size: 14px;
        text-align: center;
        line-height: 22px;
      }
      .box-remark{
        border-bottom: 0!important;
      }
      .box{
        padding: 29.5px 0;
        border-bottom: 1px solid #D1D5DA;
        .status{
          color: #68C23A
        }
      }
      .plan-name{
        color: #0366D6;
        font-family: Inter;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0;
      }

      .button-weight{
        color: #24292E;
        font-family: Inter;
        //font-size: 14px;
        font-weight: 500!important;
        //padding: 6.5px 17px;
        padding: 10px 20px;
        .percent{
          padding: 0px 6px;
          background: rgba(27, 31, 35, 0.08);
          border-radius: 100px;
          height: 16px;
          font-weight: 600;
          font-size: 12px;
          color: #586069;
          margin-left: 4px;
        }
      }
      .success{
        color: rgba(255, 255, 255, 1);
        background: rgba(46, 164, 79, 1);
      }
      .tr{
        display: flex;
        .mg-r-8{
          margin-right: 8px !important;
        }
      }
      .blue{
        color: #0366D6;
      }
      .bank-pay{
        margin-bottom: 20px;
      }

      ul {
        margin-top: 15px;
        li {
          display: flex;
          padding: 5px;
          list-style: none;
          color: #606266;
          font-size: 12px;
          line-height: 14px;
          span {
            flex: 1;
            .tag{
              .span-tag{
                display: inline-block;
                border-radius: 100px;
                height: 18px;
                background: #FFFFFF;
                padding: 0px 8px;
                font-weight: 600;
                font-size: 12px;
                line-height: 18px;
                box-sizing: content-box;
                white-space: nowrap;
                margin-bottom: 4px;
                &.verified{
                  border: 1px solid #22863a;
                  color: #22863a;
                }
                &.pending_verify{
                  border: 1px solid #dbab09;
                  color: #dbab09;
                }
                &.not_verify{
                  border: 1px solid #d73a49;
                  color: #d73a49;
                }
                &.unread-uplod{
                  border: 1px solid #f66a0a;
                  color: #c24e00;
                }
                &.professional-status, &.coupon-status, &.discount-status{
                  border: 1px solid #0366d6;
                  color: #0366d6;
                }
                &.green {
                  background: #DCFFE4;
                  color: #28A745;
                  border: none;
                }
                &.orange {
                  background-color:#FFF5B1 ;
                  color:  #B08800;
                  border: none;
                }
                &.red {
                  background: #D73A49;
                  color:#fff;
                  border: none;
                }
              }
            }
          }

          span:first-child {
            font-weight: bold;
          }
        }
        margin-bottom: 15px;
      }
      .span-status{
        border: 1px solid #616266;
        color: #616266;
      }
      .card {
        margin-bottom: 15px;
      }

      .border-b {
        //margin: 10px -15px 0 -15px;
        padding: 0 15px 10px;
        border-radius: 15px;
        border: 1px solid rgba(176, 136, 0, 0.2);

        .title {
          margin-top: 10px;
          margin-bottom: 5px;
        }
      }


      .title {
        display: inline-block;
        margin-bottom: 10px;
        padding-top: 5px;
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
        color: #24292E;
      }

      .el-input, .el-select {
        margin-bottom: 10px;

        & + .el-button {
          margin-bottom: 10px;
        }
      }
      .button-width{
        .el-button{
          width: 100%;
          font-size: 14px;
        }
      }
      .flex-align-center{
        align-items: center;
      }
      .customer-ava{
        height: 28px;
        width: 28px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #DBEDFF;
        margin-right: 10px;
        img{
          width: 100%;
          display: block;
          border-radius: 50%;
        }
      }

      .btn-list {
        .el-button {
          display: block;
          margin: 0 0 5px 0;
        }
      }

      .remark-add {
        z-index: 2;
        margin: 0 -15px;
        padding: 15px 15px 0 15px;
        //border-top: 1px solid #dddfe7;
      }

      .remarks-container {
        z-index: 1;
        max-height: 300px;
        overflow-y: auto;

        .remark-box {
          margin-bottom: 10px;
          font-size: 12px;
          color: #91939a;

          .remark-header {
            display: flex;
            justify-content: space-between;

            span:first-child {
              font-weight: bold;
            }
          }

          p {
            padding-bottom: 10px;
            color: #616266;
          }
        }
      }
    }
  }

  .void-status{
    background-color: #FFE3E6!important;
  }
  .paid-status{
    background-color: #DCFFE4!important;
  }
  .unbuyable-status{
    background-color: #FFFBDD!important;
  }
  .void-color{
    color: #CB2431;
  }
  .mt-10{
    margin-top: 10px;
    display: inline-block;
  }
  .incomplete-status{
    background: #FFFBDD;
  }
  .main-header{
    padding: 20px 88px 0px 88px;
    border-bottom: 1px solid #D1D5DA;
    background-color: #FAFBFC;
    .el-tabs--top{
      margin-top: 0!important;
    }
    ::v-deep .el-tabs__header{
      margin-bottom: 0;
      .el-tabs__item{
        font-weight: 400;
        color: #24292E!important;
        .icon{
          color: #959DA5;
          margin-right: 9px;
        }
        &.is-active{
          font-weight: 600!important;
          .icon{
            color: #24292E!important;
          }
        }
      }
      .el-tabs__active-bar{
        background: #F9826C!important;
        width: 120px;
      }
    }
    .margin-bottom{
      padding-bottom: 20px;
    }
  }
  .pdb-10{
    padding-bottom: 10px;
  }
  ::v-deep .el-table{
    border-radius: 4px;
    border: 1px solid #E1E4E8;
    tr{
      td{
        padding: 10px 15px 10px 0!important;
        vertical-align: top;
        margin-right: 15px;
        .cell{
          line-height: 20px;
          position: relative;
          height: inherit;
          padding: 0;
          color: #24292E;
          .liter-text{
            color: #6A737D;
            font-size: 12px;
            &.tag-border{
              border: 1px solid #dddfe7;
              border-radius: 4px;
              text-align: center;
              line-height: 18px;
            }
          }
        }
      }
    }
    .table-pointer{
      //cursor: pointer;
        &:hover{
          td{
            background: #fff!important;
          }
        }
      &__red{
        background: #FFE3E6;
        &:hover{
          td{
            background: #FFE3E6!important;
          }
        }
      }
    }
  }
  ::v-deep .tableHeader {
    margin-top: 30px;
    background: #F6F8FA !important;
    border-bottom: 1px solid #E1E4E8;
    th {
      background-color: #F6F8FA !important;
      font-family: Inter;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      letter-spacing: -0.15px;
      padding: 10px 0!important;
      color: #24292E!important;
      .cell{
        padding-left: 0;
      }
    }
    .button-border{
      display: inline-block;
      padding: 0px 10px;
      height: auto;
      font-size: 12px;
      border-radius: 50px;
      border: 1px solid #E1E4E8;
      color: #24292E;
      background: white;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 18px;

    }


  }
}
.mg-b-20{
  margin-bottom: 20px;
}
</style>
